import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import CostCenterGroupConstants from "../Constants/CostCenterGroupConstants";
let resultList = [];

class CostCenterGroupStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getResult() {
    return resultList;
  }

  setResult(result) {
    resultList = result;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }
  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_SUCCESS:
        this.setResult(action.result);
        break;
      case CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_FAILURE:
        this.setResult(action.result);
        break;
      case CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_SUCCESS:
        this.setResult(action.result);
        break;
      case CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_FAILURE:
        this.setResult(action.result);
        break;
      case CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_SUCCESS:
        this.setResult(action.result);
        break;
      case CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const costCenterGroupStore = new CostCenterGroupStore();
dispatcher.register(
  costCenterGroupStore.handleCallback.bind(costCenterGroupStore)
);
export default costCenterGroupStore;
